import type { JSX } from 'react';
class ChecklistInfo {
  header: string;
  items: Array<string | JSX.Element>;
  instruction: string;
  constructor(header: string, items: Array<string | JSX.Element>, instruction: string) {
    this.header = header;
    this.items = items;
    this.instruction = instruction;
  }
}

export default ChecklistInfo;
